module.exports = __webpack_public_path__ + "img/google-play.6fae4a97.svg";